const items = [
  "Custom Web Engineering",
  "Workflow Automation",
  "CRM & Internal Tools",
  "SEO & Performance",
  "Conversion Funnels",
  "Headless Commerce",
  "AI Integrations",
  "Brand Systems",
];

export default function Marquee() {
  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-white/[0.06] py-6 overflow-hidden bg-[#050505]"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#050505] to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#050505] to-transparent z-10" />
      <div className="flex marquee-track w-max gap-12">
        {[...items, ...items].map((it, i) => (
          <div
            key={i}
            className="flex items-center gap-12 text-slate-400/80 font-display text-2xl md:text-3xl tracking-tight whitespace-nowrap"
          >
            <span>{it}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-[#00F0FF]" />
          </div>
        ))}
      </div>
    </section>
  );
}
